module.exports = __webpack_public_path__ + "images/signin-person.png";